import { jsx as a, jsxs as T } from "react/jsx-runtime";
import { C as p, m as C, j as n, k as s, S as E, G as O } from "./helpers-458d7e27.js";
import { a as w } from "./TextGroup-dd19925e.js";
import { css as f } from "@emotion/react";
import "react";
import "clsx";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
const l = "TextGraphicBackground", c = new p(l), g = ({
  baseImage: e = "",
  mdImage: t = "",
  imageAltText: r = ""
}) => {
  const o = () => /* @__PURE__ */ a(
    C,
    {
      baseImage: e,
      mdImage: t,
      imageAltText: r,
      css: f`
          width: var(--image);
          z-index: 0.5;
        `,
      parallaxFactor: 3,
      className: c.getComponentClassName()
    }
  );
  return /* @__PURE__ */ a("div", { className: c.getElementClassName("container"), children: o() });
};
g.displayName = l;
const b = (e) => {
  const { image: t } = e;
  return {
    baseImage: t == null ? void 0 : t.baseImage,
    mdImage: t == null ? void 0 : t.mdImage,
    imageAltText: t == null ? void 0 : t.imageAltText
  };
}, y = () => ({
  options: {
    columnStart: n.leftInner,
    columnEnd: n.rightInner
  },
  mdOptions: {
    columnStart: s.inner3,
    columnEnd: n.rightInner
  },
  lgOptions: {
    columnStart: s.inner7,
    columnEnd: n.rightInner
  },
  xlOptions: {
    columnStart: s.inner6,
    columnEnd: n.rightInner
  }
}), m = "TextGraphicSection", i = new p(m), P = ({
  textGroup: e,
  mediaFrame: t = {
    type: "Image",
    image: {
      baseImage: "",
      imageAltText: ""
    }
  },
  topSpacer: r = "0vw",
  bottomSpacer: o = "0vw",
  componentId: d
}) => {
  const I = "white", { baseImage: N, mdImage: u, imageAltText: x } = b(t), h = {
    topSpacing: r,
    bottomSpacing: o
  }, G = y(), S = i.getComponentClassName();
  return /* @__PURE__ */ T(
    E,
    {
      theme: I,
      options: h,
      className: S,
      id: d,
      children: [
        e && /* @__PURE__ */ a(
          O,
          {
            ...G,
            className: i.getElementClassName("text-group-grid"),
            children: /* @__PURE__ */ a(w, { ...e, analyticsCompName: m })
          }
        ),
        /* @__PURE__ */ a(
          g,
          {
            baseImage: N,
            mdImage: u,
            imageAltText: x
          }
        )
      ]
    }
  );
};
P.displayName = m;
export {
  P as default
};
//# sourceMappingURL=TextGraphicSection.js.map
